<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-sm-7 col-xs-12">
                <div>
                    <!-- Кнопки зверху -->
                    
                    <!-- Преамбула -->
                    <fieldset class="mb-4">
                        <legend class="w-50">Преамбула</legend>
                        <BFormTextarea v-model="protocol.memorandum.preambula" rows="5" />
                    </fieldset>
                    
                    <!-- Учасники -->
                    <fieldset class="mb-4">
                        <legend>Учасники</legend>
                        
                        <BTable
                            :items="beforeRows"
                            :fields="beforeFields"
                            small
                            bordered
                            head-variant="light_mem"
                            responsive
                            class="mb-2"
                        >
                            <template #cell(counterparty)="{ index, item }">
                                <div class="cell-edit" @click="editCell('Учасник', 'before', index, 'counterparty')" v-html="item.counterparty || empty"></div>
                            </template>
                            <template #cell(edrpou)="{ index, item }">
                                <div class="cell-edit" @click="editCell('ЄДРПОУ', 'before', index, 'edrpou')" v-html="item.edrpou || empty"></div>
                            </template>
                            <template #cell(price)="{ index, item }">
                                <div class="cell-edit" @click="editCell('СУМА ПРОПОЗИЦІЇ', 'before', index, 'price')" v-html="item.price || empty"></div>
                            </template>
                            <template #cell(terms)="{ index, item }">
                                <div class="cell-edit" @click="editCell('Строки постачання', 'before', index, 'terms')" v-html="item.terms || empty"></div>
                            </template>
                            <template #cell(payment)="{ index, item }">
                                <div class="cell-edit" @click="editCell('Умова оплати', 'before', index, 'payment')" v-html="item.payment || empty"></div>
                            </template>
                        </BTable>
                        
                        <div class="d-flex gap-2">
                            <BButton size="sm" variant="outline-success mr-2" @click="addBeforeRow">Додати рядок</BButton>
                            <BButton size="sm" variant="outline-danger" @click="removeBeforeRow">Видалити рядок</BButton>
                        </div>
                    </fieldset>
                    
                    <!-- Переможці -->
                    <fieldset>
                        <legend>Переможці</legend>
                        
                        <BTable
                            :items="afterRows"
                            :fields="afterFields"
                            small
                            bordered
                            head-variant="light_mem"
                            responsive
                            class="mb-2"
                        >
                            <template #cell(counterparty)="{ index, item }">
                                <div class="cell-edit" @click="editCell('Переможець', 'after', index, 'counterparty')" v-html="item.counterparty || empty"></div>
                            </template>
                            <template #cell(edrpou)="{ index, item }">
                                <div class="cell-edit" @click="editCell('ЄДРПОУ', 'after', index, 'edrpou')" v-html="item.edrpou || empty"></div>
                            </template>
                            <template #cell(reason)="{ index, item }">
                                <div class="cell-edit" @click="editCell('Обґрунтування', 'after', index, 'reason')" v-html="item.reason || empty"></div>
                            </template>
                        </BTable>
                        
                        <div class="d-flex gap-2">
                            <BButton size="sm" variant="outline-success mr-2" @click="addAfterRow">Додати</BButton>
                            <BButton size="sm" variant="outline-danger" @click="removeAfterRow">Видалити</BButton>
                        </div>
                    </fieldset>
                </div>
                
                <div id="positions_control" class="mb-3 mt-5">
                    <BButton variant="outline-primary" class="btn_auto_render me-2 mr-2" @click="auto_distribute">
                        Розподілити
                    </BButton>
                    
                    <BButton variant="outline-warning" class="me-2 mr-2" @click="fillBefore('sum', false)">
                        Заповнити по сумі
                    </BButton>
                    
                    <BButton variant="outline-warning" class="me-2 mr-2" @click="fillBefore('price', false)">
                        Заповнити по ціні
                    </BButton>
                </div>
                
            </div>
            
            <div class="col-xl-4 col-lg-4 col-sm-5 col-xs-12">
                
                <div id="panel-memitem" class="panel">
                    
                    <div class="panel-container collapse show "  v-if="is_mem">
                        <div class="panel-tag mb-0">
                            Службова  на погодження Протоколу
                        </div>
                        <div class="panel-content">
                            <a target="_blank" :href="'https://office.imcagro.com.ua/docs/memorandum/' + this.protocol.memoramdum_protocol_id">
                                Протокол засідання тендерної комісії
                            </a>
                        </div>
                    </div>
                </div>
                
                <div id="panel-users" class="panel">
                    <div class="panel-container collapse show ">
                        <div class="panel-tag m-0">Погодження</div>
                        <div class="panel-content">
                            <div class="panel-body custom-scroll" style="overflow: auto;max-height: 250px;">
                                <div class="inserted">
                                    <div class="users_in">
                                        <div class="users_list m">
                                            <ul class="user_list_to_insert">
                                                <li v-for="(item,index) in users" :key="item.id || index" class="border cursor-pointer shadow-1 mt-1 mb-2">
                                                    <user_block
                                                        del_triger="remove_customer_in_protocol"
                                                        :can_del="true"
                                                        :show_vacation="true"
                                                        :user_id="item.id"
                                                        padding_class="pt-2 pl-2 pb-1"
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex">
                                <span class="badge fw-400 mr-2">
                                  <button class="btn btn-outline-success add_user waves-effect waves-themed" @click="select_user">Додати</button>
                               </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div id="panel-users" class="panel">
                    <div class="panel-container collapse show ">
                        <div class="panel-tag m-0">Файли</div>
                        <div class="panel-content">
                            <protocol_files :protocol="protocol" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <users_filter />
        
        <editor
            v-model:show="ed.show"
            v-model="ed.value"
            :title="ed.title"
            @update:modelValue="applyEdit"
        />
    </div>
</template>

<script>
import { BButton, BTable, BFormTextarea } from 'bootstrap-vue-next';
import users_filter from "../../../../shared/users/users_filter.vue";
import user_block from "../../../../shared/user/user_block/user_block.vue";
import editor from "../../../../shared/editor/editor.vue";
import Protocol_files from "./protocol_files.vue";

export default {
    name: 'protocol_memorandum',
    components: { Protocol_files, editor, users_filter, BButton, BTable, BFormTextarea, user_block },
    
    props: {
        protocol: { type: Object, required: true },
    },
    
    
    
    data() {
        return {
            empty: '<span class="text-muted">—</span>',
            ed: {
                show: false,
                title: '',
                section: null,   // 'before' | 'after' | 'standalone'
                rowIndex: -1,
                field: '',
                value: '',
                standaloneKey: '',
            },
            
            user_select_uniq: "user_adjust_mem",
            
            beforeFields: [
                { key: 'counterparty', label: 'Учасник тендеру' },
                { key: 'edrpou',      label: 'ЄДРПОУ', thClass: 'text-nowrap' },
                { key: 'price',       label: 'Цінова пропозиція з ПДВ', thClass: 'text-nowrap' },
                { key: 'terms',       label: 'Строки постачання', thClass: 'text-nowrap' },
                { key: 'payment',     label: 'Умова оплати', thClass: 'text-nowrap' },
            ],
            afterFields: [
                { key: 'counterparty', label: 'Переможець' },
                { key: 'edrpou',       label: 'ЄДРПОУ', thClass: 'text-nowrap' },
                { key: 'reason',       label: 'Обґрунтування' },
            ],
        };
    },
    
    computed: {
        is_mem () {
            return parseInt(this.protocol.memoramdum_protocol_id) > 0;
        },
        
        beforeRows: {
            get() {
                return this.protocol?.memorandum?.members || [];
            },
            set(v) {
                if (!this.protocol.memorandum) this.$set(this.protocol, 'memorandum', {});
                this.protocol.memorandum.members = Array.isArray(v) ? v : [];
            }
        },
        
        afterRows: {
            get() {
                return this.protocol?.memorandum?.winners || [];
            },
            set(v) {
                if (!this.protocol.memorandum) this.$set(this.protocol, 'memorandum', {});
                this.protocol.memorandum.winners = Array.isArray(v) ? v : [];
            }
        },
        
        users: {
            get() {
                // если вдруг пришло { id: "3511" }, приводим к массиву
                const raw = this.protocol?.memorandum?.users;
                if (Array.isArray(raw)) return raw;
                if (raw && typeof raw === 'object') return [raw];
                return [];
            },
            set(v) {
                if (!this.protocol.memorandum) this.$set(this.protocol, 'memorandum', {});
                this.protocol.memorandum.users = Array.isArray(v) ? v : [];
            }
        },
        
        appsInfo() {
            return this.protocol?.applications_info || [];
        },
        grids() {
            return this.protocol?.position_grid_add || [];
        },
    },
    
    created() {
        EventBus.$on('remove_customer_in_protocol', this.remove_customer_in_protocol);
        
        EventBus.$on('selected_users', e => {
            if (e !== undefined && e.uniq === this.user_select_uniq) {
                this.push_selected_users(e.users);
            }
        });
        
        // начальная подгрузка уже сохранённых полей меморандума (если есть)
        this.hydrateFromMemorandum();
    },
    
    watch: {
        // если протокол подменили целиком — снова гидрируем
        protocol: {
            deep: false,
            handler() {
                this.hydrateFromMemorandum();
            }
        }
    },
    
    methods: {
        // ===== Загрузка уже сохранённых данных =====
        hydrateFromMemorandum() {
            // если меморандум пуст — ничего не делаем; пользователь сам нажмёт «по сумі/по ціні»
            const mem = this.protocol?.memorandum || {};
            // гарантируем наличие контейнеров, чтобы computed setters не падали
            if (!this.protocol.memorandum) this.$set(this.protocol, 'memorandum', {});
            if (!Array.isArray(mem.members)) this.$set(this.protocol.memorandum, 'members', []);
            if (!Array.isArray(mem.winners)) this.$set(this.protocol.memorandum, 'winners', []);
            if (!mem.users) this.$set(this.protocol.memorandum, 'users', []);
            
            // ничего не пересчитываем здесь; просто показываем то, что пришло из БД
            // кнопки fillBefore(...) выполняют сознательное заполнение из заявок
        },
        
        // ===== Users =====
        remove_customer_in_protocol(user) {
            const del_id = String(user.id);
            this.users = this.users.filter(u => String(u.id) !== del_id);
        },
        
        push_selected_users(list) {
            this.users = Array.isArray(list) ? [...list] : [];
            EventBus.$emit('close_u_filter');
        },
        
        select_user() {
            EventBus.$emit('load_users_filter', {
                uniq: this.user_select_uniq,
                active: this.users
            });
        },
        
        // ===== Редактор =====
        applyEdit(val) {
            const { section, rowIndex, field, standaloneKey } = this.ed;
            
            if (section === 'before') {
                const row = this.beforeRows[rowIndex];
                if (!row) return;
                // присваиваем и создаём новый объект, чтобы сохранить реактивность
                row[field] = val;
                const next = [...this.beforeRows];
                next.splice(rowIndex, 1, { ...row });
                this.beforeRows = next;
            } else if (section === 'after') {
                const row = this.afterRows[rowIndex];
                if (!row) return;
                row[field] = val;
                const next = [...this.afterRows];
                next.splice(rowIndex, 1, { ...row });
                this.afterRows = next;
            } else if (section === 'standalone' && standaloneKey) {
                this[standaloneKey] = val;
            }
        },
        
        editCell(title, section, rowIndex, field) {
            const row = section === 'before' ? this.beforeRows[rowIndex] : this.afterRows[rowIndex];
            this.ed.title = title;
            this.ed.section = section;
            this.ed.rowIndex = rowIndex;
            this.ed.field = field;
            this.ed.standaloneKey = '';
            this.ed.value = String(row?.[field] || '<p></p>');
            this.$nextTick(() => { this.ed.show = true; });
        },
        
        // ===== Автораспределение (как было) =====
        auto_distribute() {
            EventBus?.$emit?.('winners:auto_distribute');
        },
        
        // ===== Наполнение "Учасники" из заявок; пересчёт "Переможці" из grids =====
        fillBefore(mode = 'sum', withPositionInfo = false) {
            const nextRows = [];
            const verified = this.appsInfo.filter(a => a.status === 'verificated');
            
            verified.forEach(a => {
                const priceHtml = mode === 'price' ? (a.priceprop || '') : (a.summprop || '');
                const infoParts = [];
                if (withPositionInfo && a.positioninfo) infoParts.push(`<p>${a.positioninfo}</p>`);
                if (a.paymentinfo) infoParts.push(`<p>${a.paymentinfo}</p>`);
                if (a.deliveryinfo) infoParts.push(`<p>${a.deliveryinfo}</p>`);
                
                nextRows.push({
                    counterparty: a.company,
                    author_id: a.author_id,
                    edrpou: a.edrpou,
                    price: priceHtml,
                    terms: a.datedeliveryinfo || '',
                    payment: infoParts.join(''),
                });
            });
            
            // заменить целиком (осознанная операция)
            this.beforeRows = nextRows;
            
            // и пересчитать победителей из position_grid_add
            this.buildWinnersFromGrids();
        },
        
        // ===== Переможці з protocol.position_grid_add =====
        buildWinnersFromGrids() {
            const mapByApp = new Map(); // appId -> { hrn, usd, eur, evalSum }
            
            for (const g of this.grids) {
                const appId = String(g.id).replace(/^app/, '');
                const acc = mapByApp.get(appId) || { hrn: 0, usd: 0, eur: 0, evalSum: 0 };
                
                for (const r of g.records_push || []) {
                    const qty = parseFloat(r['quantity_protocol' + appId] ?? 0) || 0;
                    if (!qty) continue;
                    
                    const priceEval = parseFloat(r['Price_' + appId] ?? 0) || 0;
                    const sumEval = parseFloat(r['Sum_' + appId] ?? (priceEval * qty)) || 0;
                    acc.evalSum += sumEval;
                    
                    const curId = String(r['currency_app_' + appId] ?? '');
                    const valPrice = parseFloat(r['ValPrice_' + appId] ?? 0) || 0;
                    const part = valPrice * qty;
                    
                    if (curId === '1') acc.hrn += part;
                    else if (curId === '2') acc.usd += part;
                    else if (curId === '3') acc.eur += part;
                }
                
                mapByApp.set(appId, acc);
            }
            
            const nextWinners = [];
            for (const [appId, totals] of mapByApp.entries()) {
                const app = this.appsInfo.find(a => String(a.id) === String(appId));
                if (!app) continue;
                
                const rate = this.getAPPtaxrate(app);
                const hasPDV = this.hasPDV(app);
                
                const chunks = [];
                const fmt = n => this.nf(n);
                if (totals.hrn > 0) chunks.push(`${fmt(hasPDV ? totals.hrn * (1 + rate) : totals.hrn)} грн ${hasPDV ? '' : '(без ПДВ)'}`);
                if (totals.usd > 0) chunks.push(`${fmt(hasPDV ? totals.usd * (1 + rate) : totals.usd)} USD ${hasPDV ? '' : '(без ПДВ)'}`);
                if (totals.eur > 0) chunks.push(`${fmt(hasPDV ? totals.eur * (1 + rate) : totals.eur)} EUR ${hasPDV ? '' : '(без ПДВ)'}`);
                
                let tail = hasPDV ? `(з ПДВ ${(rate * 100).toFixed(0)}%)` : `(не платник ПДВ)`;
                const reason = `Вартість закупівлі ${chunks.join(' ')} ${tail}`;
                
                nextWinners.push({
                    counterparty: app.company,
                    author_id: app.author_id,
                    edrpou: app.edrpou,
                    reason,
                    evalSum: totals.evalSum,
                });
            }
            
            nextWinners.sort((a, b) => (b.evalSum ?? 0) - (a.evalSum ?? 0));
            this.afterRows = nextWinners;
        },
        
        // ===== PDV helpers =====
        hasPDV(app) {
            return String(app.has_pdv) !== '0';
        },
        getAPPtaxrate(app) {
            switch (String(app.has_pdv)) {
                case '1': return 0.20;
                case '2': return 0.14;
                case '3': return 0.07;
                default:  return 0;
            }
        },
        
        // ===== форматирование =====
        nf(n) {
            const x = Number(n || 0);
            return x.toFixed(2).replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ');
        },
        
        // ===== ручные строки =====
        addBeforeRow() {
            this.beforeRows = [
                ...this.beforeRows,
                { counterparty: '', author_id: null, edrpou: '', price: '', terms: '', payment: '' },
            ];
        },
        removeBeforeRow() {
            const next = [...this.beforeRows];
            next.pop();
            this.beforeRows = next;
        },
        addAfterRow() {
            this.afterRows = [
                ...this.afterRows,
                { counterparty: '', author_id: null, edrpou: '', reason: '', evalSum: 0 },
            ];
        },
        removeAfterRow() {
            const next = [...this.afterRows];
            next.pop();
            this.afterRows = next;
        },
        
        openTenderUser(userId) {
            if (!userId) return;
            EventBus?.$emit?.('show_tenderuser', { user_id: userId });
        },
    },
};
</script>

<style scoped>
.cell-edit { cursor: pointer; min-height: 25px; }
</style>
